const state = {
  roleSelect: [],
  groupSelect: [],
  currIndex: []

}
const mutations = {
  changhandler (state, data) {
    state[data.key] = data.val
  },
  changeCurrIndex (state, data) {
    state[data.key].push(data.val)
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
